import { withInstall } from '../../utils/install';
import CountDown from './index.vue';

export const IvueCountDown = withInstall(CountDown);
export default IvueCountDown;

export * from './index.vue';
